import { ReactElement, useCallback } from 'react';
import { Stack, Tooltip } from '@mui/material';
import { faFileArrowDown as ExportListIcon } from '@fortawesome/free-solid-svg-icons';
import { useSnackbar } from 'notistack';

import { searchItemsToExportV2 } from '~services/item';
import { useLazyRequest } from '~hooks/useLazyRequest';
import { formatterDate } from '~utils/formatter';
import { downloadFileByRequest } from '~utils/download';

import { useDashboardVariantV2GiverContentInTransitTabContext } from '../../../Context';

import {
  DashboardVariantV2GiverContentActionsIconButton,
  DashboardVariantV2GiverContentActionsIconButtonIcon,
} from '../../../../../styles';

const DashboardVariantV2GiverContentInTransitTabActionsActionables =
  (): ReactElement => {
    const { enqueueSnackbar } = useSnackbar();

    const {
      parseFiltersRequest,
      table: {
        queryParams: { pagination },
      },
    } = useDashboardVariantV2GiverContentInTransitTabContext();

    const [, loadingSearchToExport, , executeSearchToExport] = useLazyRequest({
      request: searchItemsToExportV2,
      withPostSuccess: (response) => {
        if (response.headers && response.data) {
          const currentDate = formatterDate(new Date(), { format: 'YYYYMMDD' });

          const defaultFileName = `pedidos-en-transito-${currentDate}.csv`;

          downloadFileByRequest(
            response.headers,
            response.data,
            defaultFileName,
          );

          enqueueSnackbar(`Se ha exportado los pedidos correctamente`, {
            variant: 'success',
          });
        } else {
          enqueueSnackbar(
            'No se pudo exportar los pedidos, intente nuevamente',
            { variant: 'error' },
          );
        }
      },
      withPostFailure: () => {
        enqueueSnackbar('No se pudo exportar los pedidos, intente nuevamente', {
          variant: 'error',
        });
      },
    });
    const handleExportItems = useCallback(async () => {
      await executeSearchToExport({
        filters: parseFiltersRequest(),
        pagination,
      });
    }, [executeSearchToExport, pagination, parseFiltersRequest]);

    return (
      <Stack direction="row" spacing={1}>
        <Tooltip title="Exportar listado" arrow>
          <DashboardVariantV2GiverContentActionsIconButton
            color="secondary"
            variant="outlined"
            onClick={handleExportItems}
            loading={loadingSearchToExport}
          >
            <DashboardVariantV2GiverContentActionsIconButtonIcon
              icon={ExportListIcon}
            />
          </DashboardVariantV2GiverContentActionsIconButton>
        </Tooltip>
      </Stack>
    );
  };

export default DashboardVariantV2GiverContentInTransitTabActionsActionables;
